module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/partnerNetworkBrand-67859c473f34565ec7aba6d46d68ebad.png";